import type {
  AdminCaseListResponse,
  AdminCasePatch,
  AdminCasePatchResponse,
  AdminCaseView,
} from '@repo/shared'
import { json, request } from './api'
import type { GetToken } from './lib/auth'

/** 한 번에 받는 최대 수 (서버 adminCaseListQuerySchema 의 limit 상한) */
const LIST_LIMIT = 200
/** 사례는 많아야 수백 개다. 서버가 끝을 알려 주지 않는 이상한 경우에도 멈추게 둔다 */
const MAX_PAGES = 20

/** DELETE /admin/community/posts/:id 응답. linkedCaseIds 는 C19 에서 더한 칸이라 옛 서버면 없다 */
export interface PostDeleteResult {
  ok: true
  linkedCaseIds?: string[]
}

/**
 * 완성 사례 관리자 API (설계 7장). api.ts 를 덜 고치려고 따로 둔다.
 * 목록은 거르기 없이 전부 받아 화면에서 거른다. 언어 탭·나라·상태별 개수를 함께 보이려는 것이다
 */
export const casesApi = {
  listAll: async (getToken: GetToken): Promise<AdminCaseView[]> => {
    const items: AdminCaseView[] = []
    let offset: number | null = 0
    for (let i = 0; i < MAX_PAGES && offset !== null; i++) {
      const page: AdminCaseListResponse = await request<AdminCaseListResponse>(
        getToken,
        `/admin/cases?limit=${LIST_LIMIT}&offset=${offset}`,
      )
      items.push(...page.items)
      offset = page.nextOffset
    }
    return items
  },
  patch: (getToken: GetToken, id: string, patch: AdminCasePatch) =>
    request<AdminCasePatchResponse>(
      getToken,
      `/admin/cases/${encodeURIComponent(id)}`,
      json('PATCH', patch),
    ),
  /** 지운 글에 연결된 사례를 함께 숨긴다. 서버 숨김 로직은 사례 PATCH 그대로 쓴다 */
  hideAll: async (getToken: GetToken, ids: readonly string[]) => {
    for (const id of ids) await casesApi.patch(getToken, id, { hidden: true })
  },
}
